var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPainting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#7584f2",
    r: 256
  }))))))))), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-2.377-.033-4.748-.097-7.109l-130.832-130.832-22.022 24.952-85.549-85.55-142.571 270.019 55.862 55.862-40.584 68.538 54.029 54.029c17.952 3.987 36.612 6.091 55.764 6.091 141.385 0 256-114.615 256-256z",
    fill: "#4855b7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m106.039 365.101h152.03v35h-152.03z",
    fill: "#e9edf5",
    transform: "matrix(.249 -.969 .969 .249 -233.792 463.835)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m312.446 306.586h35v152.03h-35z",
    fill: "#cdd2e1",
    transform: "matrix(.969 -.249 .249 .969 -84.751 94.028)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m238.5 57.461h35v254.117h-35z",
    fill: "#e9edf5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.12 57.461h17.38v254.117h-17.38z",
    fill: "#cdd2e1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m381.071 227.761-250.142 99.719v-209.421h250.142z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m381.071 118.059h-124.951v209.421l124.951-99.719z",
    fill: "#e9edf5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 186.615,
    cy: 186.475,
    fill: "#ffce00",
    r: 37.085
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m130.929 327.48 95.264-90.993 43.629 31.995 71.262-78.533 39.987 37.812v99.719z",
    fill: "#ff6c52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m381.071 227.761-39.987-37.812-71.262 78.533-13.702-10.048v69.046h124.951z",
    fill: "#ff432e"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m211.041 88.179h89.918v35h-89.918z",
    fill: "#bec3d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.12 88.179h44.839v35h-44.839z",
    fill: "#9196aa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m160.217 303.201h191.565v35h-191.565z",
    fill: "#bec3d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.12 303.201h95.662v35h-95.662z",
    fill: "#9196aa"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainting);
export default __webpack_public_path__ + "static/media/painting.f9fc6375824b06a9c2cf59eb929954d7.svg";
export { ForwardRef as ReactComponent };